// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/@oppein/oppein-component/dist/oppein-component.css
// module id = 2162
// module chunks = 68